// Login.tsx — экран входа (показывается session-слоем при отсутствии сессии).
// Паролей нет: вход по magic-link из бота. ?error=login приходит с
// /auth/callback при недействительном/истёкшем токене.

import { useSearchParams } from 'react-router-dom';

export default function Login() {
  const [params] = useSearchParams();
  const failed = params.get('error') === 'login';

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="logo">TG</div>
        <h2>TG-oprosnik</h2>
        <div className="sub2">Панель управления отчётами</div>

        {failed && (
          <div className="login-error">
            Ссылка недействительна или истекла. Запросите новую в боте.
          </div>
        )}

        <div className="login-steps">
          <p>Паролей нет. Вход — через Telegram-бота:</p>
          <ol>
            <li>Откройте бота в Telegram</li>
            <li>
              Отправьте команду <span className="toks">/dashboard</span>
            </li>
            <li>Перейдите по одноразовой ссылке из ответа</li>
          </ol>
        </div>

        <div className="login-foot">
          Ссылка действует 10 минут и срабатывает один раз. Доступ определяется вашей ролью.
        </div>
      </div>
    </div>
  );
}
